import router from "@/router";
import axios from "axios";
import { Message } from "element-ui";

let baseUrl = "https://triplefireman.com/";

const httpService = axios.create({
    baseURL:baseUrl,
    timeout:3000
})
// 请求拦截
httpService.interceptors.request.use(function(config){
    // 设置header
    config.headers.Authorization = window.sessionStorage.getItem('token');
    config.headers['Accept-Language'] = 'zh-hans'
    return config
}, function(error){
    // 对数据进行处理
    return Promise.reject(error);
})

// 响应拦截
httpService.interceptors.response.use(function(response){
    if (response.data.code == '300' || response.data.code == '301' || response.data.code == '302') {
        router.replace('/login')
    }
    return  response
}, function(error){
    return Promise.reject(error)
})

export function fileUpload(url , param = {}, form = null){
    return new Promise((resolve, reject)=>{
        
        httpService({
            url:url,
            method:'post',
            params:param,
            data:form,
            header:{'Content-Type':'multipart/form-data'}
        }).then(response => {
            resolve(response.data);
        }).catch(error=>{
            reject(error);
        });
    })
}

export function getServerUrl(){
    return baseUrl
}

const request = options => {
    const { url, method, params,formData, isFile} = options;    
    return new Promise((resolve, reject)=>{
        httpService({
            url:`${baseUrl}${url}`,
            method: method,
            params:  params,
            data:formData ? formData : params,
            headers : isFile ? {'Content-Type':'multipart/form-data'} : null
        }).then(response => {
            let {status} = response
            
            if (+status === 200) {
                let {code, message} = response.data
                
                if (+code === 200) {
                    resolve(response.data);
                }else {
                    Message.error(message)    
                }
            }else {
                Message.error('网络请求失败')
                reject(Error('网络请求失败'));
            }
        }).catch(error=>{
            Message.error('网络请求失败')
            reject(error);
        });
    })
}


const getRequest = (url, params = {}) => request({ url, method: 'GET',   params });
const postRequest = (url, params = {}) => request({ url, method: 'POST',  params });
const deleteRequest = (url, params = {}) => request({ url, method: 'DELETE', params });
const putRequest = (url, params = {}) => request({ url, method: 'PUT', params });
const reqRequest = (url, method, params = {},formData, isFile) => request({ url, method, params,formData, isFile });

export default {
    get : getRequest,
    post: postRequest,
    del : deleteRequest,
    put : putRequest,
    req:reqRequest,
    fileUpload,
    getServerUrl,
}